<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @reload="() => $refs.tableHeader.query()"
      @openDetailDialog="openDetailDialog"
      @openImageDialog="openImageDialog"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>

    <DetailDialog
      :title="
        $l('INDEX.dialog_title_production_order_goods_detail') ||
          '订单产品信息详情'
      "
      :visible.sync="detailDialogOptions.visible"
      :orderGoodsCode="detailDialogOptions.code"
    />
    <GoodsImagesDialog
      :visible.sync="goodsImagesDialogOptions.visible"
      :orderGoodsCode="goodsImagesDialogOptions.code"
      :title="'查看订单产品图片信息'"
    />
  </div>
</template>
<script>
import DetailDialog from '../detail/dialog.vue'
import Main from './main'
import Header from './header'
import GoodsImagesDialog from '../../../goods-images'
export default {
  components: { Main, Header, DetailDialog, GoodsImagesDialog },
  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      detailDialogOptions: {
        visible: false,
        code: '',
      },
      goodsImagesDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .pendingOrderGoodsListApi({ orderCode: this.orderCode, ...form })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    openDetailDialog({ orderGoodsCode }) {
      this.detailDialogOptions = { code: orderGoodsCode, visible: true }
    },
    openImageDialog({ orderGoodsCode }) {
      this.goodsImagesDialogOptions = { code: orderGoodsCode, visible: true }
    },
  },
}
</script>
